<!-- Form -->
@if (bodyForm) {
  <medsurf-design-form-control-form
    [formGroup]="bodyForm"
    [className]="'h-full'"
    (onSubmit)="onSubmit()">
    <!-- Editor -->
    <medsurf-editor [formField]="false"
      [control]="bodyForm.controls.body"
      [placeholder]="'global.text'"
      [class]="'h-full'"
      [fullHeight]="true"
      [autogrow]="false"
      [toolbarExcludes]="['marker']"
    (valueChange)="onSubmit()"></medsurf-editor>
  </medsurf-design-form-control-form>
}
